import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { RippleButton } from "../components/RippleButton";
import { Blobs } from "../components/Effects";
import { Loader2, ShieldCheck, Database } from "lucide-react";
import { adminFirebaseLogin } from "../lib/firebase";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const user = await adminFirebaseLogin(email, password);
      localStorage.setItem("woofsy_admin_token", user.uid || "firebase-admin-auth-session");
      localStorage.setItem("woofsy_admin_email", email);
      nav("/admin");
    } catch (e) {
      if (e.code === "auth/invalid-credential" || e.code === "auth/user-not-found" || e.code === "auth/wrong-password") {
        setErr("Invalid email or password");
      } else {
        setErr(e.message || "Firebase Login Failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 relative">
      <Blobs />
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
        className="relative glass rounded-[2rem] p-8 sm:p-10 w-full max-w-md shadow-2xl">
        <div className="font-heading font-extrabold text-3xl text-woofsy-dark mb-1">🐾 Woof<span className="text-woofsy-primary">sy</span></div>
        <p className="text-woofsy-dark/60 mb-8">Admin dashboard login</p>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-4">
          <div>
            <label className="text-xs font-medium text-woofsy-dark/60 mb-1.5 block">Email</label>
            <input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
              className="w-full rounded-xl border border-woofsy-dark/10 bg-white/70 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-woofsy-primary" placeholder="info@example.co.in" />
          </div>
          <div>
            <label className="text-xs font-medium text-woofsy-dark/60 mb-1.5 block">Password</label>
            <input data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" required
              className="w-full rounded-xl border border-woofsy-dark/10 bg-white/70 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-woofsy-primary" placeholder="••••••••" />
          </div>
          {err && <p data-testid="login-error" className="text-sm text-red-500">{err}</p>}
          <RippleButton type="submit" variant="primary" data-testid="login-submit" className="w-full py-3.5" disabled={loading}>
            {loading ? <Loader2 className="w-5 h-5 animate-spin mx-auto" /> : "Sign In"}
          </RippleButton>
        </form>
        <a href="/" className="block text-center text-sm text-woofsy-dark/50 mt-6 hover:text-woofsy-primary">← Back to site</a>
      </motion.div>
    </div>
  );
}
